export const TEXTS = {
    ADD: "ADD",
    FREE: "FREE",
};

export const STEAL_DEAL_ITEM_IMAGE_SIZE = {
    WIDTH: 64,
    HEIGHT: 64,
};

export const STEAL_DEAL_V2_IMAGE_SIZE = {
    WIDTH: 44,
    HEIGHT: 64,
};